/**
 * Each Order Monitor card fills half of the space under the tab bar.
 * The parent column is the viewport, so the two cards stay on the page at every height.
 * The card content must be allowed to shrink, or it grows to every row and the card clips the grid instead of scrolling it.
 */
export const monitorPaneSx = {
  flex: '1 1 0',
  minHeight: 0,
  height: 'auto',
  overflow: 'hidden',
  '& > .MuiCardContent-root': { minHeight: 0 },
} as const;
